<template>
  <div class="content style-guide-component">

    <div class="container">

      <p><b>Headings Default</b></p>

      <h1>h1 - Título <span class="emphasis-variant">destaque</span>?</h1>
      <h2>h2 - Título <span class="emphasis-variant">destaque</span>?</h2>
      <h3>h3 - Título <span class="emphasis-variant">destaque</span>?</h3>
      <h4>h4 - Título <span class="emphasis-variant">destaque</span>?</h4>
      <h5>h5 - Título <span class="emphasis-variant">destaque</span>?</h5>
      <h6>h6 - Título <span class="emphasis-variant">destaque</span>?</h6>

      <br />
      <br />

      <p><b>Headings class</b></p>

      <p class="title-1">.title-1 - Título <span class="emphasis-variant">destaque</span>?</p>
      <p class="title-2">.title-2 - Título <span class="emphasis-variant">destaque</span>?</p>
      <p class="title-3">.title-3 - Título <span class="emphasis-variant">destaque</span>?</p>
      <p class="title-4">.title-4 - Título <span class="emphasis-variant">destaque</span>?</p>
      <p class="title-5">.title-5 - Título <span class="emphasis-variant">destaque</span>?</p>
      <p class="title-6">.title-6 - Título <span class="emphasis-variant">destaque</span>?</p>

      <br />
      <br />

      <p><b>Text body default</b></p>

      <p>
        This is Photoshop's version  of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
        Aenean sollicitudin, lorem quis bibendum auctor, nisi elit consequat ipsum, nec sagittis sem nibh id elit.
        Duis sed odio sit amet nibh vulputate cursus a sit amet mauris. Morbi accumsan ipsum velit. Nam nec tellus a odio
        tincidunt auctor a ornare odio. Sed non  mauris vitae erat consequat auctor eu in elit. Class aptent taciti
        sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris in erat justo. Nullam ac urna eu
        felis dapibus condimentum sit amet a augue. Sed non neque elit. Sed ut imperdiet nisi. Proin condimentum
        fermentum nunc. Etiam pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis
        neque. Suspendisse in orci enim.
      </p>

      <br />

      <p><b>Buttons and tag "a" class </b> .btn (.btn--primary, .btn--secondary, .btn--tertiary, .btn--sm, .btn--lg, .btn--block)</p>

      <p>
        Os botões seguem a padronização BEM, referência no site oficial <a href="http://getbem.com/introduction" target="_blank">http://getbem.com/introduction</a>
      </p>

      <p>Buttons default and background-color</p>

      <div class="row">
        <a href="#" class="btn btn--primary">.btn .btn--primary</a>
        <a href="#" class="btn btn--secondary">.btn .btn--secondary</a>
        <a href="#" class="btn btn--tertiary">.btn .btn--tertiary</a>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StyleGuide',
  computed: {},
  methods: {
    showAlert (message) {
      alert(message);
    },
  },
  mounted () {},
};
</script>

<style scoped lang="scss">
.style-guide-component {
  padding: 250px 0;
  div[class^="col-"], div[class*=" col-"] {
    margin-bottom: 20px;
  }

  .btn {
    margin: 10px;
  }

  .bg-demo {
    padding: 10px;
    display: inline-block;
    margin-right: 10px;

    &.bg-text {
      background: #efefef;
    }
  }
}
</style>
